import React, { ReactNode } from 'react';
import { FieldRenderProps } from 'react-final-form';
import PasswordHelper from './PasswordHelper';
import eye from '../../../../img/createAccount/eye.svg';
import eyeslash from '../../../../img/createAccount/eye-slash.svg';

type Props = FieldRenderProps<string> & {
  placeholder: string;
  limit?: number;
  required?: boolean;
  withHelper?: boolean;
  customError?: string;
  onChange?: () => void;
};

type State = {
  showPassword: boolean;
};

class PasswordInput extends React.Component<Props, State> {
  static defaultProps = {
    fieldType: 'input',
    limit: null,
    required: false,
    withHelper: false,
  };

  state: State = {
    showPassword: false,
  };

  toggleShowPassword = (): void =>
    this.setState((previousState) => ({ showPassword: !previousState.showPassword }));

  render(): ReactNode {
    const htmlFor = this.props.input.name;
    let fieldType = 'password';
    if (this.state.showPassword) {
      fieldType = 'text';
    }
    return (
      <div className={`text-input-group ${this.props.meta.error && this.props.meta.touched ? 'input-error' : ''}${this.props.meta.touched && this.props.customError ? ' input-custom-error' : ''}`}>
        <input
          type={fieldType}
          className="text-input-field"
          value={this.props.input.value}
          onChange={(e) => {
            this.props.input.onChange(e);
            if (this.props.onChange) this.props.onChange();
          }}
          placeholder={this.props.placeholder}
          id={htmlFor}
          maxLength={this.props.limit}
          required={this.props.required}
          autoComplete="new-password"
          onPaste={(e) => {
            e.preventDefault();
            return false;
          }}
        />
        {this.props.withHelper && <PasswordHelper value={this.props.input.value} />}
        <label htmlFor={htmlFor} className={`text-input-placeholder ${this.props.required && 'text-input-placeholder--mandatory'}`}>{this.props.placeholder}</label>
        {
            this.props.input.value
                        && (
                        <button
                          className="text-input-button-container password"
                          onClick={this.toggleShowPassword}
                          type="button"
                        >
                          <img alt="Show password" src={`${this.state.showPassword ? eyeslash : eye}`} />
                        </button>
                        )
                }
        {
          this.props.meta.touched
          && ((this.props.customError && <span className="text-error">{this.props.customError}</span>)
          || (this.props.meta.error && <span className="text-error">{this.props.meta.error}</span>))
        }
      </div>
    );
  }
}

export default PasswordInput;
